import React from 'react';
import styled from "styled-components";
import {CaptionListProps} from "../../../types/caption";
import {useAtom} from "jotai";
import {AIcaptionListState} from "../../../states/caption";
import {saveState} from "../../../states/action";

type CaptionDataProps = {
  captionData: CaptionListProps | null
}

/**
 자막 데이터 (글)

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */
export default function OriginCaptionData( {captionData}: CaptionDataProps) {

  const [AICaptionList, setAICaptionList] = useAtom(AIcaptionListState);
  const [, setSave] = useAtom(saveState);

  return (
    <DataArea>
      <div className="can_resizable1 origin_txt_area">
        <label htmlFor="caption_txt1" className="hide">원본 자막</label>
        <textarea
          className="input_text type_align_left"
          name="originCaption"
          data-id={captionData?.id}
          value={captionData?.caption}
          onChange={(e) => {

            const cuurrentSegmentId = e.currentTarget.dataset.id!
            const targetSegment = globalThis.peaksInstance?.segments.getSegment(cuurrentSegmentId)
            if (targetSegment
              && captionData) {
              const [_1stLine, _2ndLine] = targetSegment.labelText!.split('\n\n')!
              const [segmentSequenceStr,] = _1stLine.split(' ')!;
              targetSegment.update({labelText: `${_1stLine} \n\n${e.currentTarget.value}`});
            }

            const captionListUpdated = AICaptionList.map((segment, index) => {
              return segment.id === cuurrentSegmentId
                ? {
                  ...segment,
                  caption: e.currentTarget.value
                } as CaptionListProps
                : segment
            })
            setAICaptionList(captionListUpdated);
            setSave({needSaveOn: true});
          }}


        ></textarea>
      </div>
    </DataArea>
  );
}

const DataArea = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  /* flex: 1 1 1; */
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  z-index: 10;
  padding: 0 5px 0 0;

  .origin_txt_area {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    position: relative;
    height: 100%;

    padding: 0 0 0 5px;
    line-height: 25px;
    text-align: center;

    .input_text {
      height: 100%;
      padding: 12px;
      font-size: 17px;
      overflow: hidden;
      overflow-y: auto;
      border: 1px solid #1f1f1f;
      background:#4e4e4e33;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-thumb {
        -webkit-border-radius: 3px;
        border-radius: 3px;
        background: #3e3e3e;
      }

      &::-webkit-scrollbar-track-piece {
        background: #1f1f1f;
      }

    }

  }
`;
